<template>
  <div>
    <div class="website-basket-padding border-bottom">
      {{ $resourceString["Checkout.Shipping.Title"] }}
    </div>
    <div class="d-flex justify-content-start flex-row">
      <div class="d-flex flex-column mr-5">
        <p class="font-16 font-weight-bold mt-2">Ship To:</p>
        <select class="font-16" name="address">
          <option value="address1">Address #1</option>
          <option value="address2">Address #2</option>
          <option disabled>──────────</option>
          <option value="newaddress" disabled>Add new address</option>
        </select>
        <a class="font-16 mt-2 danger" id="editAddressBtn">Edit Address</a>

        <!-- The Modal -->
        <div id="addressModal" class="modal">
          <!-- Modal content -->
          <div class="modal-content">
            <span class="close">&times;</span>
            <p>Some text in the Modal..</p>
          </div>
        </div>

        <a class="font-16 mt-4 danger"
          >Need to ship your items to more than one address?</a
        >
      </div>
      <div class="d-flex flex-column ml-5 mr-5">
        <p class="font-16 font-weight-bold mt-2">Sample Delivery Options:</p>
        <input type="radio" id="second" name="ship" value="second" checked />
        <label class="font-16 font-weight-bold" for="second">Second day</label>
        <input type="radio" id="standard" name="ship" value="standard" />
        <label class="font-16 font-weight-bold" for="standard">Standard</label>
        <input type="radio" id="ground" name="ship" value="ground" />
        <label class="font-16 font-weight-bold" for="ground">Ground</label>
      </div>
      <div class="d-flex flex-column ml-5">
        <p class="font-16 font-weight-bold mt-2">Note:</p>
        <p class="font-16 w-50">
          All Design Trays are shipped separately FedEx Overnight
        </p>
      </div>
    </div>
    <div class="website-basket-padding border-bottom"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {};
</script>

<style>
</style>